import { api } from 'redux/api/index.api';

export const kolimmoApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchKolimmoAutologin: builder.mutation({
      query: ({ organizationId, userId }) => ({
        url: `organizations/${organizationId}/users/${userId}/autologin`,
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: 'throw',
});

export const { useFetchKolimmoAutologinMutation } = kolimmoApi;
